import { render, staticRenderFns } from "./PhoneNumberField.vue?vue&type=template&id=b33b017e&scoped=true&lang=pug"
import script from "./PhoneNumberField.vue?vue&type=script&lang=js"
export * from "./PhoneNumberField.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumberField.vue?vue&type=style&index=0&id=b33b017e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33b017e",
  null
  
)

export default component.exports